import { create } from 'zustand';

import type { VariantType } from '@/utilities/tracking';

const variantTypeStore = create<{ variantType?: VariantType }>(() => ({}));

export const setVariantType = (variantType?: VariantType) =>
  variantTypeStore.setState({ variantType });

export const consumeVariantType = (): VariantType | undefined => {
  const { variantType } = variantTypeStore.getState();

  setVariantType();

  return variantType;
};
